<template>
    <div>
        <div
            id="page-container"
            class="h-screen overflow-auto bg-neutral-100 dark:bg-gray-800">
            <HeaderFrontend class="bg-white" />
            <ImpersonateBanner />
            <SystemBanner />
            <BaseSlideOver
                :header-color="'primary'"
                :title="$t(slideOverStore.title)"
                :description="$t(slideOverStore.description)"
                :model-value="slideOverStore.isSlideOverOpen"
                @update:modelValue="slideOverStore.setSlideOverOpen($event)">
                <Component :is="components[slideOverStore.component]" />
            </BaseSlideOver>
            <main class="max-w-7xl mx-auto ">
                <!-- Your content -->
                <div
                    v-if="underConstruction"
                    class="px-4 sm:px-6 lg:px-8 py-2 sm:py-5 md:py-10 ">
                    <ComingSoonPage
                        hide-dashboard-link />
                </div>
                <div v-else>
                    <CmsFrontendAlert v-if="cmsEnabled" />
                    <div class="px-4 sm:px-6 lg:px-8 py-2 sm:py-5 md:py-10 ">
                        <slot />
                    </div>
                </div>
            </main>
            <FooterFrontend />
        </div>
    </div>
</template>

<script setup>
import FundingProgramsSelection from "@/components/global/FundingPrograms/FundingProgramsSelection"
import ProcessAddDocuments from "@/components/global/Processes/ProcessAddDocuments"
import ProcessCopySettings from "@/components/global/Processes/ProcessCopySettings"
import HeaderFrontend from "@/components/layouts/HeaderFrontend"
import AuthWrapper from "@/components/pages/auth/AuthWrapper.vue"
import {useNotification} from "@/composables/useNotification"
import {useAuthStore} from "@/store/auth"
import {useCmsNavItemsStore} from "@/store/cmsNavItems"
import {useSlideOverStore} from "@/store/slideOver"
import {useWebsocketStore} from "@/store/websockets"

const authStore = useAuthStore()
const slideOverStore = useSlideOverStore()
const route = useRoute()
const notification = useNotification()
const { t: $t } = useI18n()

const components = {
    FundingProgramsSelection,
    AuthWrapper,
    ProcessCopySettings,
    ProcessAddDocuments,
}

const underConstruction = computed(() => useRuntimeConfig()?.public?.underConstruction)
const cmsEnabled = computed(() => useRuntimeConfig()?.public?.cmsEnabled)

onMounted(() => {
    if (authStore.userData) {
        useWebsocketStore().init()
    }

    if (cmsEnabled.value) {
        useCmsNavItemsStore().fetchCmsNavItems()
    }

    if (route.query?.resetPassword === "true") {
        slideOverStore.setSlideOverOpen(true)
        slideOverStore.setTitle('auth.resetPassword')
        slideOverStore.setDescription('')
        slideOverStore.setComponent('AuthWrapper')
        slideOverStore.setContext(null)
    }

    if (route.query?.verified == 1) {
        notification.success($t('auth.emailVerified'))
    }
})

useHead({
    bodyAttrs: {
        class: 'h-full bg-gray-50'
    },
    htmlAttrs: {
        class: 'h-full'
    }
})
</script>
